<template>
  <el-dialog
    left
    :title="title"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    width="450px"
    @open="ïntializeForm()"
    @close="handleCancel()"
    style="margin: 0 auto;"
    :visible.sync="isShow"
    class="contactMdl col-lg-12 col-sm-12 col-12 col-md-12"
  >
    <form @submit.prevent="formSave()">
      <div v-if="value.newStage" class="d-flex" style="margin-bottom: 50px;">
        <div>Stage</div>
        <input
          type="text"
          style=" position: absolute;width:83%;z-index: 1;margin-top:25px"
          v-model="value.data.stageName"
          required
          class="form-control team-form"
        />
        <div
          class="color-picker"
          @click="colorPickerModel=!colorPickerModel"
          :style="`background: ${colors} 0% 0% no-repeat padding-box;`"
        ></div>
        <swatches v-model="colors" @input="updateValue" v-if="colorPickerModel" />
      </div>
      <div v-else>
        <div>
          Notes
          <span v-if="required" class="required">*</span>
          <span v-else>(Optional)</span>
        </div>
        <textarea
          placeholder="Notes"
          :required="required"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="value.data.stageNote"
        ></textarea>
      </div>
      <div class="edit-company-action-button-row py-4" style="margin:0px">
        <button
          type="button"
          @click="handleCancel()"
          class="todo-form-cancel-button btn-outline-secondary"
        >Cancel</button>
        <button
          type="submit"
          class="todo-form-submit-button btn btn-primary"
          style="height: 35px;"
          :disabled="isSaving"
        >
          Save
          <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
        </button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import { Select, Option, Dialog } from "element-ui";
import { Swatches } from "vue-color";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
export default {
  computed: {
    ...mapGetters("diligence_stage", ["diligenceStageData"]),
    ...mapGetters("role", ["checkRole"]),
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    title: {
      get() {
        return this.value.title;
      },
    },
  },
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    Swatches,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      newStage: Boolean,
      title: String,
    },
  },
  data() {
    return {
      isSaving: false,
      colors: "#FFCCBCFF",
      colorPickerModel: false,
      required: false,
      newStage: false,
    };
  },
  methods: {
    handleCancel() {
      this.value.data.stageNote = "";
      this.value.data.dealStageName = "";
      this.colorPickerModel = false;
      this.colors = "#FFCCBCFF";
      this.required = false;
      this.value.isShow = false;
      this.isSaving = false;
      if (this.newStage) {
        this.$emit("new-stage-added");
      } else this.$emit("cancel-refresh");
    },
    updateValue(data) {
      this.colors = data.hex8;
      this.colorPickerModel = false;
    },
    ïntializeForm() {
      if (this.value.title == "Why Pass?") this.required = true;
      if (this.value.title == "Add Diligence Stage")
        this.value.data.stageName = "";
      this.value.data.stageNote = "";
      this.newStage = false;
      this.colorPickerModel = false;
      this.colors = "#FFCCBCFF";
    },
    formSave() {
      let self = this;
      self.isSaving = true;
      let payload = {};
      let url = "";
      if (self.value.newStage) {
        let check = this.diligenceStageData.filter(
          (item) =>
            item.stage_name.toLocaleLowerCase() ==
            self.value.data.stageName.toLocaleLowerCase()
        );
        if (check.length > 0) {
          self.$toaster.error("Stage already exists.");
          self.isSaving = false;
          return;
        }
        let stageObj = {};
        stageObj.stage = self.value.data.stageName;
        stageObj._id = self.value.data._id;
        stageObj.diligence_stage == stageObj.dealStageName;
        if (self.colors) stageObj.colors = self.colors;
        payload = stageObj;
        url = "diligence_stage/apiPostStageInst";
      } else if (self.value.title == "Why Pass?") {
        let stageItem = self.diligenceStageData.find(
          (item) => item.stage_name == self.value.data.dealStageName
        );
        payload.rejectedNotes = self.value.data.stageNote;
        payload.deal_stage = stageItem._id;
        payload.workspace_id = self.$route.params.workspace_id;
        payload._id = self.value.data._id;
        payload.is_archive = true
        url = "diligence/apiStatusUpdate";
      } else {
        let noteObj = {};
        noteObj.note = self.value.data.stageNote;
        noteObj._id = self.value.data._id;
        noteObj.diligence_stage = self.value.data.dealStageName;
        let stageItem = self.diligenceStageData.find(
          (item) => item.stage_name == noteObj.diligence_stage
        );
        noteObj.stageId = stageItem._id;
        payload = noteObj;
        payload.color = stageItem.color;
        payload.portfolio_item = self.value.data.portfolio_item;
        payload.is_archive = false
        url = "diligence/apiPatchDiligenceStageInst";
      }
      self.$store
        .dispatch(url, payload)
        .then((data) => {
          if (self.value.newStage) {
            self.$store
              .dispatch("diligence_stage/apiFetchDiligenceStage")
              .then((stages) => {
                this.newStage = true;
                self.value.data.stageNote = "";
                self.value.newStage = false;
                self.value.title = "Add Note";
                self.value.data.dealStageName = data.success.stage_name;
                self.isSaving = false;
                self.$toaster.success("Saved successfully.");
              });
          } else {
            self.tableDataReset(payload);
          }
        })
        .catch((err) => {
          self.isSaving = false;
          self.$toaster.error("Fail to update the stage.");
        });
    },
    tableDataReset(payload) {
      let self = this;
      let notificationObj = {
        name: self.$parent.diligenceEdit.name,
        organization:
          self.$parent.diligenceEdit && self.$parent.diligenceEdit.organization
            ? self.$parent.diligenceEdit.organization
            : "",
        ucid: self.$parent.diligenceEdit.ucid,
      };

      if (self.value.context == "Archived" && self.value.title != "Why Pass?") {
        self.$parent.tabulator.deleteRow(self.$parent.diligenceEdit._id);
        self.value.isShow = false;
        self.isSaving = false;
        self.$toaster.success("Saved successfully.");
        notificationObj.stage = payload.diligence_stage;
      } else if (self.value.title == "Why Pass?") {
        self.$parent.tabulator.deleteRow(self.$parent.diligenceEdit._id);
        self.value.isShow = false;
        self.isSaving = false;
        self.$toaster.success("Saved successfully.");
        notificationObj.stage = "Rejected";
      } else if (payload.color && payload.diligence_stage) {
        self.$parent.oldEditData = {};
        self.$parent.diligenceEdit[
          "dealStageName"
        ] = `<div style="height:25px;background-color:${payload.color}" class="badge invest-badge px-3">${payload.diligence_stage}</div>`;

        self.$parent.tabulator.updateData([self.$parent.diligenceEdit]);
        notificationObj.stage = payload.diligence_stage;
        if (this.newStage) {
          self.$emit("new-stage-added");
        }
        self.value.isShow = false;
        self.isSaving = false;
        self.$toaster.success("Saved successfully.");
      }
      self.sendDiligenceNotifications(notificationObj);
    },
    sendDiligenceNotifications(diligenceData) {
      let self = this;
      if (this.checkRole && this.checkRole.toLowerCase() == "collaborator") {
        diligenceData.account_id = this.$route.params.account_id;
        diligenceData.workspace_id = this.$route.params.workspace_id;
        this.$store.dispatch("notifications/apiDiligenceCollaboratorReceipt", {
          type: "stage",
          diligenceData,
        });
      }
    },
  },
};
</script>
<style>
</style>